import ReactDOM from "react-dom/client";
import AppAuth from "./AppAuth.jsx";
import { registerLicense } from "@syncfusion/ej2-base";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./content/styles/scss/main.scss";

registerLicense(import.meta.env.PUBLIC_SYNCFUSION_LIC);

ReactDOM.createRoot(document.getElementById("root")).render(
  <>
    <AppAuth />
    <div id="modals" />
  </>
);
